export default {
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
   scope: "email profile openid https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile"
}